
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { HistoryCommentType } from '@/features/shipment-history/types';

@Component
export default class CommentItem extends Vue {
  @Prop({ required: true }) comment!: HistoryCommentType;

  get friendlyDate(): string {
    const isToday = moment(this.comment.date).isSame(moment(), 'day');
    const date = isToday ? this.$t('global.today') : moment(this.comment.date).format('LL');

    return `${date} - ${moment(this.comment.date).format('hh:mm A')}`;
  }

  // private mounted() {
  //   this.$el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  // }
}
